import { connect } from 'react-redux';
import { EkycServiceForm } from './EkycServiceForm';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { NotificationAction } from '../../../app/common/notifications/notificationsActionType';
import { EkycServiceActions } from './ekycServiceActions';
import { EkycServiceAction } from './ekycServiceActionType';
import { IEkycServiceRequest } from './ekycServiceRequest';

function mapStateToProps(state: any) {
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.EKYC
            : '',
        locale: state.app.locale,
        appConfig: state.app.appConfig,
        memberLoggedIn: state.app.memberLoggedIn,
        member: state.member,
        localeSet: state.app.locale,
        clientConfig: state.app.clientConfig,
        supportPageUrl:
            state.app.clientConfig.supportPageUrl || 'mailto:rakuten-privacy@mail.rakuten.com',
        isSubmitting: state.accountSecurity.unlinkEkycService,
    };
}

function mapDispatchToProps(
    dispatch: ThunkDispatch<IReduxRootState, {}, EkycServiceAction | NotificationAction>,
) {
    return {
        unlinkEkycService: (values: IEkycServiceRequest) => {
            dispatch(EkycServiceActions.unlinkEKYCService(values));
        },
    };
}
const IdentityVerificationContainer = connect(mapStateToProps, mapDispatchToProps)(EkycServiceForm);
export default IdentityVerificationContainer;
